<div id="parent" style="height: auto;">
    <div id="suspects-alt-heat-map-headers-main">
        <div id="suspects-alt-heatmap-headers">
            <div class="suspects-alt-heatmap-header1">
                {{header1_line1}}<br />
            </div>
            <div class="suspects-alt-heatmap-header2">{{header2}}</div>
            <div class="suspects-alt-heatmap-header3">
                {{header3_line1}}<br />
                {{header3_line2}}
            </div>
        </div>
        <div id="suspects-alt-heat-map-export">
            <dx-button icon="exportxlsx" class="ap-blue-btn" (onClick)="exportExcel($event)" text="Export to Excel">
            </dx-button>
        </div>
    </div>
    <div>
        <h6 style="margin-left: 15px" class="ap-green">{{header5}}</h6>
    </div>
    <div class="suspects-alt-heatmap-container">
        <div id="suspects-alt-heatmap1-viewport" class="suspects-heatmap-viewport" [class.info-text]="showInfoText">
        </div>
        <div style="margin-right: 15px"></div>
        <div id="suspects-alt-heatmap1-legend" class="suspects-heatmap-legend" [hidden]="hideLegend1">
            <b>MTD</b>
            <hr />
        </div>
    </div>
    <div id="suspects-alt-heat-map-grid">
        <div style="margin-top: 20px;"></div>
        <dx-data-grid #SuspectAltHeatMapGrid id="SuspectAltHeatMapGrid" [showBorders]="true" [showColumnLines]="true"
            [showRowLines]="true" [elementAttr]="{class: 'suspects-alt-heat-map-grid-size'}"
            [dataSource]="suspectAltHeatMap.demandForPlantHeatMap" [wordWrapEnabled]="false" showBorders="true">
            <dxo-toolbar>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-export [enabled]="true"></dxo-export>
            <dxi-column dataField="geoLabel" cssClass="column-group-sub-header" caption="Area"></dxi-column>
            <dxi-column dataField="milesToASU" cssClass="column-group-sub-header"
                caption="Miles To Selected ASU"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="custCount" caption="Suspect Count">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="mtd" caption="Predicted MTD"> </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="mtDnoAP"
                caption="Predicted MTD, No AP Accts"></dxi-column>
            <dxo-summary>
                <dxi-total-item column="custCount" summaryType="sum">
                </dxi-total-item>
                <dxi-total-item column="mtd" summaryType="sum">
                </dxi-total-item>
                <dxi-total-item column="mtDnoAP" summaryType="sum">
                </dxi-total-item>
            </dxo-summary>
            <dxo-load-panel [enabled]="false"></dxo-load-panel>
        </dx-data-grid>
    </div>
    <div style="margin-top: 20px;"></div>
    <h6 style="margin-left: 15px" class="ap-green">{{header4}}</h6>
    <div style="margin-top: 20px;"></div>
    <div class="suspects-alt-heatmap-container">
        <div id="suspects-alt-heatmap2-viewport" class="suspects-heatmap-viewport" [class.info-text]="showInfoText">
        </div>
        <div style="margin-right: 15px"></div>
        <div id="suspects-alt-heatmap2-legend" class="suspects-heatmap-legend">
            <b>MTD</b>
            <hr />
        </div>
    </div>
</div>